<form #formRef="ngForm" [class.is-new]="isNew">
	<bb-page-header [backOnMobile]="['/adservices/lineitems']" [icon]="'th-list'" [title]="lineitem?.title">

		<span class="subtitle"> {{ lineitem?.code }} </span>

		<bb-status *ngIf="lineitem" [(ngModel)]="lineitem.status" name="status" [labelOn]="'ENABLED' | translate"
			[labelOff]="'DISABLED' | translate"></bb-status>

	</bb-page-header>

	<bb-adstats-blocks *ngIf="!isNew" [lineitemCode]="lineitem?.code" [statsDate]="statsDate"></bb-adstats-blocks>

	<div class="body-columns-container">
		<div class="body-column tab-container" cdkScrollable>
			<p *ngIf="adBlocker" class="warning message"><i class="fa fa-warning"></i> {{ 'ADS_ARE_DISABLED' | translate }}</p>
	
			<lineitem-details-settings *ngIf="entity && tabLoadedBefore('settings')" [isNew]="isNew" [lineitem]="entity" [form]="form" [hidden]="activeTab !== 'settings'"></lineitem-details-settings>
		</div>

		<div class="body-column preview-container">
			<bb-date-presets
				(onChanged)="datesChanged($event)"
				[icon]="'line-chart'"
				[presets]="adServicesService.datePresets"
				[time]="true"
				[minDate]="minDate"
				[minDateWarning]="'HELP.PROJECT_STATS_DATE_CORRECTED' | translate: {date: (minDate | date)}">
			</bb-date-presets>

			<div class="adunit-container">
				<h3>{{ 'ASSIGNED_TO_AD_UNITS' | translate }}</h3>
				<bb-entity-selector [placeholder]="'ASSIGN_TO_AD_UNIT' | translate" [icon]="'chain'" [entityType]="'adunit'" [selectOnly]="true" (optionSelected)="adunitSelected($event?.id)"></bb-entity-selector>
		
				<div class="adunit-manage-text">
					<strong>{{ 'MANAGE_LINE_ITEM_PRIORITY_PER_ADUNIT' | translate }}:</strong>
				</div>
		
				<div class="lineitem-adunits-container">
		
					<div class="adunit-target" *ngFor="let adunit of relatedAdUnits">
						<div *ngIf="!adunit.hidden">
							<div class="adunit-title">
								<span class="title">
									{{ 'AD_UNIT' | translate }}: {{ adunit.title }}
								</span>
								<span class="adunit-unlink pull-right" (click)="removeLineitemFromAdunit(adunit.id, lineitem?.id)" title="{{'UNLINK_FROM_AD_UNIT' | translate}}" ><i class="fa fa-unlink"></i></span>
								<a class="adunit-edit pull-right fa fa-edit" [routerLink]="['/adservices/adunits', adunit.id, 'general']" title="{{'EDIT_AD_UNIT' | translate}}"></a>
							</div>
							<div class="adunit-target-bordered">
								<div class="adunit-metrics" *ngIf="adunitStats && adunitStats[adunit?.id]">
				
									<div class="metric-item">
										<strong>{{ 'INVENTORY' | translate }}</strong> {{adunitStats[adunit.id].inits | number}}
									</div>
									<div class="metric-item">
										<strong>{{ 'FILL_RATE' | translate }}</strong> {{adunitStats[adunit.id].fillrate | number}}%
									</div>
									<div class="metric-item">
										<strong>{{ 'IMPRESSIONS' | translate }}</strong> {{adunitStats[adunit.id].views | number}}
									</div>
									<div class="metric-item">
										<strong>{{ 'CTR' | translate }}</strong> {{adunitStats[adunit.id].clickrate | number}}%
									</div>
									<div class="metric-item" *ngIf="adunit?.outstream">
										<strong>{{ 'IN_VIEW' | translate }}</strong> {{ ( adunitStats[adunit.id].inview || 0 ) | number}}
										<!-- <span *ngIf="placementRateWarningText">	
											<bb-info icon="warning" [contents]="inViewWarningText | translate:{ date: (newDataFromDate | date) }"></bb-info>&nbsp;
										</span> -->
									</div>
									<div class="metric-item" *ngIf="adunit?.outstream">
										<strong>{{ 'PLACEMENT_RATE' | translate }}</strong> {{ ( adunitStats[adunit.id].placementRate || 0 ) | number}}%
										<!-- <span *ngIf="placementRateWarningText">	
											<bb-info icon="warning" [contents]="placementRateWarningText | translate:{ date: (newDataFromDate | date) }"></bb-info>&nbsp;
										</span> -->
									</div>
								</div>
								
								<div class="assigned-label">
									<strong>
										{{ 'ASSIGNED_LINE_ITEMS_PRIORITY' | translate }}:
									</strong>
								</div>
								<div class="lineitem-adunit-lineitems-container">
									<ul cdkDropList (cdkDropListDropped)="lineitemDragged(adunit.id, $event)" class="adunit-target-lineitem-list">
										<ng-container *ngFor="let lineitemId of adunit.assignedLineitems; let i = index;">
											<li cdkDrag cdkDragLockAxis="y" class="adunit-target-lineitem-item {{ lineitemId == lineitem?.id ? 'current-lineitem' : '' }}"
													title="{{('DRAG_TO_CHANGE_PRIORITY' | translate) + ', ' + ('DOUBLE-CLICK_TO_EDIT' | translate).toLowerCase()}}">
												<div class="adunit-target-lineitem-list-line" *ngIf="lineitemId == lineitem?.id">
													
												</div>
												<span><i class="fa fa-bars"></i></span>
												<span class="position">{{i + 1}}</span><span class="lineitem-title">{{getLineItem(lineitemId)?.title}}<strong *ngIf="getLineItem(lineitemId)?.subtype"> ({{ getLineItem(lineitemId)?.subtype | uppercase | translate }})</strong></span>
												<span class="status right" [innerHtml]="getLineItem(lineitemId) | statusIcon"></span>
											</li>
										</ng-container>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<bb-entity-details
				[entity]="entity"
			></bb-entity-details>
		</div>
	</div>
</form>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" (onDelete)="delete()" [form]="form"
	[entity]="entity">
</bb-actions-bar>
